/* AirFlow — bandeaux produits : defilement auto + fleches + scroll manuel (pause/reprise) + swipe mobile */
(function(){
  if(window.__afMq)return;window.__afMq=1;
  function ready(fn){if(document.readyState!=='loading')fn();else document.addEventListener('DOMContentLoaded',fn);}
  ready(function(){
    var st=document.createElement('style');
    st.textContent='.af-mqx{overflow-x:auto !important;overflow-y:hidden !important;scrollbar-width:none;-ms-overflow-style:none;scroll-behavior:auto;}'+
      '.af-mqx::-webkit-scrollbar{display:none;}'+
      '.af-mqx .products-grid,.af-mqx .af-mq-track{animation:none !important;}'+
      '.af-arrows-wrap{position:relative;}'+
      '.af-arrow{position:absolute;top:50%;transform:translateY(-50%);z-index:30;width:46px;height:46px;border-radius:50%;border:none;background:#fff;box-shadow:0 4px 16px rgba(0,0,0,.18);color:#1f8a7c;font-size:24px;line-height:1;cursor:pointer;display:flex;align-items:center;justify-content:center;transition:transform .15s,background .15s,color .15s;}'+
      '.af-arrow:hover{background:#1f8a7c;color:#fff;transform:translateY(-50%) scale(1.08);}'+
      '.af-arrow.left{left:8px;}.af-arrow.right{right:8px;}'+
      '@media(max-width:600px){.af-arrow{display:none;}}'+
      '.af-mq-card{display:flex;flex-direction:column;}'+
      '.af-mq-card .card-title{min-height:2.7em;}'+
      '.af-mq-card a.card-btn{margin-top:auto;}'+
      '.product-card{display:flex;flex-direction:column;}'+
      '.product-card .card-title{min-height:2.6em;}'+
      '.product-card .card-btn{margin-top:auto;}';
    document.head.appendChild(st);

    function setup(container,inner,cardSel){
      if(!container||!inner||container.dataset.afmq)return;container.dataset.afmq='1';
      inner.style.animation='none';
      container.classList.add('af-mqx');

      // wrapper relatif pour les fleches
      var wrap=document.createElement('div');wrap.className='af-arrows-wrap';
      container.parentNode.insertBefore(wrap,container);wrap.appendChild(container);
      var left=document.createElement('button');left.className='af-arrow left';left.setAttribute('aria-label','Produit précédent');left.innerHTML='‹';
      var right=document.createElement('button');right.className='af-arrow right';right.setAttribute('aria-label','Produit suivant');right.innerHTML='›';
      wrap.appendChild(left);wrap.appendChild(right);

      var card=container.querySelector(cardSel);
      var step=card?Math.round(card.getBoundingClientRect().width)+24:260;

      var hw=0;function calcHW(){hw=inner.scrollWidth/2;}calcHW();
      window.addEventListener('resize',function(){calcHW();});
      setTimeout(calcHW,1500);

      var paused=false,idle=null,STEP=0.9,pos=container.scrollLeft;
      function pause(){paused=true;if(idle)clearTimeout(idle);}
      function resumeSoon(){if(idle)clearTimeout(idle);idle=setTimeout(function(){paused=false;},1200);}

      // setInterval (pas requestAnimationFrame : rAF peut etre gele en iframe/onglet non focus) + accumulateur flottant
      function tick(){
        if(paused){pos=container.scrollLeft;}
        else{pos+=STEP;container.scrollLeft=pos;}
        if(hw>0){if(pos>=hw){pos-=hw;container.scrollLeft=pos;}else if(pos<0){pos+=hw;container.scrollLeft=pos;}}
      }
      setInterval(tick,20);

      // pause-au-survol UNIQUEMENT sur appareils a vraie souris (evite le faux mouseenter bloquant sur mobile)
      if(window.matchMedia&&window.matchMedia('(hover: hover)').matches){
        container.addEventListener('mouseenter',function(){paused=true;});
        container.addEventListener('mouseleave',function(){resumeSoon();});
      }
      ['wheel','touchstart','pointerdown'].forEach(function(ev){container.addEventListener(ev,function(){pause();},{passive:true});});
      ['touchend','touchcancel','pointerup','pointercancel','mouseup'].forEach(function(ev){container.addEventListener(ev,function(){resumeSoon();},{passive:true});});

      left.addEventListener('click',function(){pause();container.scrollBy({left:-step,behavior:'smooth'});resumeSoon();});
      right.addEventListener('click',function(){pause();container.scrollBy({left:step,behavior:'smooth'});resumeSoon();});
    }

    setup(document.querySelector('.af-home-mq'),document.querySelector('.af-home-mq .products-grid'),'.product-card');
    setup(document.querySelector('.af-mq'),document.querySelector('.af-mq .af-mq-track'),'.af-mq-card');
  });
})();
